

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="BadgeBox" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { BadgeBoxProps } from './BadgeBox.ts';
import BadgeBox from './BadgeBox.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-badge-box';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<BadgeBoxProps>();
const changableProps = useChangableProps(componentName, props);

</script>
